import { IconAiPen_16 } from 'src/assets/icons/16x16/IconAiPen_16';
import { IconImage_16 } from 'src/assets/icons/16x16/IconImage_16';
import { IconMaximize2_16 } from 'src/assets/icons/16x16/IconMaximize2_16';
import { IconMegaphone_16 } from 'src/assets/icons/16x16/IconMegaphone_16';
import { IconMessageCircle_16 } from 'src/assets/icons/16x16/IconMessageCircle_16';
import { IconMinimize2_16 } from 'src/assets/icons/16x16/IconMinimize2_16';
import { IconRocket_16 } from 'src/assets/icons/16x16/IconRocket_16';
import { IconType_16 } from 'src/assets/icons/16x16/IconType_16';
import { GENERATION_IMPROVE_MODE } from 'src/data/generation';

const ICONS_INFO = {
  [GENERATION_IMPROVE_MODE.improveImage]: { Icon: IconRocket_16 },
  [GENERATION_IMPROVE_MODE.changeImageOverlay]: { Icon: IconType_16 },
  [GENERATION_IMPROVE_MODE.changeImageStyle]: { Icon: IconImage_16 },
  [GENERATION_IMPROVE_MODE.continueWriting]: { Icon: IconAiPen_16 },
  [GENERATION_IMPROVE_MODE.improveEngaging]: { Icon: IconAiPen_16 },
  [GENERATION_IMPROVE_MODE.improveSimilar]: { Icon: IconAiPen_16 },
  [GENERATION_IMPROVE_MODE.boostScoreEngaging]: { Icon: IconRocket_16 },
  [GENERATION_IMPROVE_MODE.boostScoreSimilar]: { Icon: IconRocket_16 },
  [GENERATION_IMPROVE_MODE.makeCasual]: { Icon: IconMessageCircle_16 },
  [GENERATION_IMPROVE_MODE.makeLonger]: { Icon: IconMaximize2_16 },
  [GENERATION_IMPROVE_MODE.makeShorter]: { Icon: IconMinimize2_16 },
  [GENERATION_IMPROVE_MODE.changeTov]: { Icon: IconMegaphone_16 },
};

export const getIconInfo = (action) => ICONS_INFO[action] || null;
